module.exports = __webpack_public_path__ + "img/5.20ce15e6.png";